<div class="confirm-container">
  <h1
    mat-dialog-title
    class="dialog-title"
  >
    <mat-icon class="warning-icon">warning</mat-icon>
    {{ 'SEND_TO_APP' | translate }}
  </h1>

  <mat-dialog-content>
    @if (data.routeIsEmpty) {
    <p>{{ 'NO_EMA_RECIPIENTS' | translate }}</p>
    } @else {
    <p>{{ 'NO_EMA_USERS_AVAILABLE' | translate }}</p>
    @if (visibleRecipients.length > 0) {
    <ul class="recipient-list" data-testid="send-to-app-recipients">
      @for (recipient of visibleRecipients; track recipient.userId) {
      <li>
        <span class="recipient-name">{{ recipient.name || ('UNKNOWN_EMA_USER' | translate) }}</span>
        <span class="recipient-last-seen">
          @if (recipient.lastSeen) {
          {{ recipient.lastSeen | calculateAlertTime }}
          } @else {
          {{ 'LAST_SEEN_UNKNOWN' | translate }}
          }
        </span>
      </li>
      }
    </ul>
    @if (hiddenRecipientCount > 0) {
    <p class="more-recipients" data-testid="send-to-app-more-recipients">
      {{ 'AND_MORE_EMA_USERS' | translate : { count: hiddenRecipientCount } }}
    </p>
    }
    }
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <!-- Cancel takes the initial focus so a stray keypress cannot send the alarm -->
    <button
      mat-stroked-button
      class="cancel-btn"
      cdkFocusInitial
      data-testid="send-to-app-cancel"
      (click)="cancel()"
    >
      <mat-icon>close</mat-icon>
      {{ 'CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      class="confirm-btn"
      data-testid="send-to-app-confirm"
      (click)="confirm()"
    >
      <mat-icon>check</mat-icon>
      {{ 'SEND_ANYWAY' | translate }}
    </button>
  </mat-dialog-actions>
</div>
